import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";

import images from "../../assets/img/images";

const styles = {
  tooltip: {
    marginTop: "0px",
    fontSize: "1em",
    fontWeight: "400",
  },
  downloadIcon: {
    cursor: "pointer",
    "@media print": {
      display: "none",
    },
  },
};

const DownloadIcon = (props) => {
  const { classes, exportCsv } = props;

  return (
    <Tooltip
      title={I18n.get("profiles_downloadCsv")}
      placement="bottom"
      classes={{ tooltip: classes.tooltip }}
    >
      <img
        src={images.downloadIconColored}
        onClick={exportCsv}
        className={classes.downloadIcon}
        alt="download"
        style={props.style}
      />
    </Tooltip>
  );
};

export default withStyles(styles)(DownloadIcon);
